import configEnv from "@/enums/configEnv";
import LogService from "@/services/LogService";

const getLang = {
  methods: {
    getLang() {
      const pattern = `(?<=${configEnv.own_url}/)(${configEnv.allowed_langs_pattern})(?=/|$)`;
      const regex = new RegExp(pattern);
      const res = regex.exec(window.location.href);
      LogService.log("lang extr", res, window.location.href);
      return Array.isArray(res) ? res[0] : configEnv.default_wp_language;
    },
  },
};

export default getLang;
